"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ConfirmCloseModal;
var react_1 = __importDefault(require("react"));
function ConfirmCloseModal(_a) {
    var open = _a.open, mode = _a.mode, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    if (!open)
        return null;
    var confirmLabel = mode === "chat" ? "End Chat" : "End Call";
    return (react_1.default.createElement("div", { style: {
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.25)",
            display: "grid",
            placeItems: "center",
            zIndex: 2000,
        } },
        react_1.default.createElement("div", { role: "dialog", "aria-modal": "true", "aria-label": "Close session confirmation", style: {
                width: 320,
                background: "#fff",
                borderRadius: 12,
                border: "1px solid #E5E7EB",
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                padding: "16px 16px 12px",
            } },
            react_1.default.createElement("div", { style: {
                    textAlign: "center",
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#111827",
                    marginBottom: 12,
                } }, "Are you sure you want to close this session?"),
            react_1.default.createElement("div", { style: { display: "flex", justifyContent: "center", gap: 12 } },
                react_1.default.createElement("button", { onClick: onConfirm, style: {
                        padding: "10px 16px",
                        borderRadius: 999,
                        border: "1px solid #4C1D95",
                        background: "#4C1D95",
                        color: "#fff",
                        fontWeight: 600,
                        cursor: "pointer",
                    } }, confirmLabel),
                react_1.default.createElement("button", { onClick: onCancel, style: {
                        padding: "10px 16px",
                        borderRadius: 999,
                        border: "1px solid #D1D5DB",
                        background: "#fff",
                        color: "#4B5563",
                        fontWeight: 600,
                        cursor: "pointer",
                    } }, "Continue")))));
}
